import React from "react";
import Row from "../../common/Row";
import { useTranslation } from "react-i18next";

import card from "../../../resources/promises/card_icon.png";
import check from "../../../resources/promises/check_icon.png";
import growth from "../../../resources/promises/growth_icon.png";

const Promises = () => {
  const { t } = useTranslation("home");

  return (
    <div className="text-center py-4">
      <div className="text-2xl text-emerald-400 py-4 font-bold">
        {t("promises.title")}
      </div>

      <Row spaceClass="md:space-x-4 space-y-4">
        {/* Block 1 */}
        <div className="bg-green-600 rounded-xl p-8 md:w-1/3 w-1/2 mx-auto">
          <div className="bg-white rounded-full h-32 w-32 flex items-center mx-auto">
            <img className="w-3/4 mx-auto" src={card} alt="img not found" />
          </div>
          <div className="text-xl text-white p-4">
            {t("promises.block1.heading")}
          </div>
          <div className="text-white p-4">
            {t("promises.block1.line1")}<br />
            {t("promises.block1.line2")}<br />
            {t("promises.block1.line3")}<br />
            {t("promises.block1.line4")}<br />
          </div>
        </div>

        {/* Block 2 */}
        <div className="bg-green-600 rounded-xl p-8 md:w-1/3 w-1/2 mx-auto">
          <div className="bg-white rounded-full h-32 w-32 flex items-center mx-auto">
            <img className="w-3/4 mx-auto" src={check} alt="img not found" />
          </div>
          <div className="text-xl text-white p-4">
            {t("promises.block2.heading")}
          </div>
          <div className="text-white p-4">
            {t("promises.block2.line1")}<br />
            {t("promises.block2.line2")}<br />
            {t("promises.block2.line3")}<br />
            {t("promises.block2.line4")}<br />
          </div>
        </div>

        {/* Block 3 */}
        <div className="bg-green-600 rounded-xl p-8 md:w-1/3 w-1/2 mx-auto">
          <div className="bg-white rounded-full h-32 w-32 flex items-center mx-auto">
            <img className="w-3/4 mx-auto" src={growth} alt="img not found" />
          </div>
          <div className="text-xl text-white p-4">
            {t("promises.block3.heading")}
          </div>
          <div className="text-white p-4">
            {t("promises.block3.line1")}<br />
            {t("promises.block3.line2")}<br />
            {t("promises.block3.line3")}<br />
            {t("promises.block3.line4")}<br />
          </div>
        </div>
      </Row>
    </div>
  );
};

export default Promises;
